import { render } from "./Expense.vue?vue&type=template&id=424315c2&scoped=true&ts=true"
import script from "./Expense.vue?vue&type=script&lang=ts"
export * from "./Expense.vue?vue&type=script&lang=ts"

import "./Expense.vue?vue&type=style&index=0&id=424315c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424315c2"]])

export default __exports__